import { getQueryParams } from '../routing/getQueryParams';
import { Data } from '../signup-data/DATA';
import { getQueryParamKeyFromDataKey } from './getQueryParamKeyFromDataKey';
import { QUERY_PARAM } from './QUERY_PARAM';
const SKIP_PREFILLED_PARAM = 'skip_prefilled';
const NON_PREFILLABLE = [Data.Industry, Data.JobRole, Data.Password, Data.CodeVerification, Data.CrmExperienceLevel];
export const getPrefilledDataKeys = () => {
  const queryParams = getQueryParams();
  return Object.values(Data).filter(dataKey => queryParams[getQueryParamKeyFromDataKey(dataKey)]);
};
export const getPrefilledSignupData = () => {
  const queryParams = getQueryParams();
  return Object.values(Data).filter(dataPoint => !NON_PREFILLABLE.includes(dataPoint)).reduce((prefills, dataKey) => {
    const valueToPrefill = queryParams[getQueryParamKeyFromDataKey(dataKey)];

    if (valueToPrefill !== null && valueToPrefill !== undefined) {
      prefills[dataKey] = queryParams[getQueryParamKeyFromDataKey(dataKey)];
    }

    return prefills;
  }, {});
};
export const shouldSkipPrefilledSteps = () => {
  return SKIP_PREFILLED_PARAM in getQueryParams();
};
export const isPostVerification = () => {
  const queryParams = getQueryParams();
  return Boolean(queryParams[QUERY_PARAM.TOKEN]) && Boolean(queryParams[QUERY_PARAM.EMAIL]);
};
export const isPreVerification = () => {
  return !isPostVerification();
};